import { render, staticRenderFns } from "./ToggleOptions.vue?vue&type=template&id=64490970&scoped=true&"
import script from "./ToggleOptions.vue?vue&type=script&lang=js&"
export * from "./ToggleOptions.vue?vue&type=script&lang=js&"
import style0 from "./ToggleOptions.vue?vue&type=style&index=0&id=64490970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64490970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64490970')) {
      api.createRecord('64490970', component.options)
    } else {
      api.reload('64490970', component.options)
    }
    module.hot.accept("./ToggleOptions.vue?vue&type=template&id=64490970&scoped=true&", function () {
      api.rerender('64490970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Map/components/ToggleOptions.vue"
export default component.exports